<template>
  <div :class="mode">
    <slot name="body"></slot>
  </div>
</template>
<script>
export default {
  props: {
    mode: {
      type: String,
      default: 'widget-body'
    }
  }
}
</script>